import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

export default function CreditNoteTableView() {
    return (
        <TableView.Table>
            <Table.Column<CreditNote>
                accessorKey="id"
                header="ID"
                size={144}
                cell={({ row }) => <Table.Cells.IDCell id={row.original.custom_id || row.original.id} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<CreditNote>
                accessorKey="invoice_id"
                header="Invoice ID"
                size={144}
                cell={({ getValue }) => <Table.Cells.IDCell id={getValue() || "—"} />}
                enableSorting={false}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<CreditNote>
                accessorKey="client_name"
                header="Client Name"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<CreditNote>
                accessorKey="status_label"
                header="Status"
                size={176}
                cell={({ getValue }) => <Table.Cells.StatusCell objectType="credit_note" status={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<CreditNote>
                accessorKey="credit_note_type_label"
                header="Type"
                size={144}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue() || "—"} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<CreditNote>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as CreditNoteLabel[])?.map((label: CreditNoteLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<CreditNote>
                accessorKey="total"
                header="Total"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<CreditNote>
                accessorKey="date_issued"
                header="Date Issued"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<CreditNote>
                accessorKey="last_modified_at"
                header="Last Modified"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
